import React from 'react';
import { Row, Container, Col } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Link from 'next/link';
import OnlyOnFlaivySite from './OnlyOnFlaivySite';
import domainModel from 'domain-model';
import FooterPrivab from './FooterPrivab';

// @ts-ignore
function Footer({ shopConfig }) {
  const {
    address,
    zipCode,
    city,
    country,
    aboutUs,
    homePage,
    instagram,
    facebook,
    youtube,
    linkedin,
    contactPhone,
    contactEmail,
    organization,
  } = shopConfig;
  const { name } = organization;
  if (domainModel.shopConfig.isPrivabShop(shopConfig)) {
    return <FooterPrivab shopConfig={shopConfig} />;
  }
  return (
    <footer className="py-5 px-4 bg-dark d-print-none mt-3">
      <Container>
        <OnlyOnFlaivySite>
          <Row className="justify-content-center letter-spacing-1 text-md ">
            <Col className="text-center">
              <Link
                href="https://supplier.qvanti.com"
                className="text-white pb-2 text-decoration-none"
                style={{ borderBottom: '1px solid white' }}
              >
                Är du leverantör?
              </Link>
            </Col>
          </Row>
        </OnlyOnFlaivySite>
        <Row className="justify-content-between text-sm text-gray-500 subtitle mt-5">
          <Col xs={12} md={6} lg={3} className="mt-3">
            <p className="subtitle text-white">kontakt</p>
            <p className="subtitle ">{name}</p>
            <a
              href={`tel:${contactPhone}`}
              className="subtitle text-decoration-none"
            >
              {contactPhone}
            </a>
            <div>
              <a
                href={`mailto:${contactEmail}`}
                className="subtitle text-decoration-none"
              >
                {contactEmail}
              </a>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} className="mt-3">
            <p className="subtitle text-white">postadress</p>
            <p className="subtitle ">
              {address} <br />
              {zipCode} {city} <br />
              {country}
            </p>
          </Col>
          <Col xs={12} md={6} lg={3} className="mt-3">
            <p className="subtitle text-white">{name}</p>
            {aboutUs && (
              <a
                href={aboutUs}
                target="_blank"
                rel="noopener noreferrer"
                className="subtitle text-decoration-none"
              >
                <div>om oss</div>
              </a>
            )}
            {homePage && (
              <a
                href={homePage}
                target="_blank"
                rel="noopener noreferrer"
                className="subtitle text-decoration-none"
              >
                <div>hemsida</div>
              </a>
            )}
          </Col>
          <Col xs={12} md={6} lg={3} className="mt-3">
            <p className="subtitle text-white">sociala medier</p>
            {instagram && (
              <div>
                <a
                  href={instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subtitle "
                >
                  Instagram
                </a>
              </div>
            )}
            {facebook && (
              <div>
                <a
                  href={facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subtitle "
                >
                  facebook
                </a>
              </div>
            )}
            {youtube && (
              <div>
                <a
                  href={youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subtitle "
                >
                  youtube
                </a>
              </div>
            )}
            {linkedin && (
              <div>
                <a
                  href={linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="subtitle "
                >
                  linkedin
                </a>
              </div>
            )}
          </Col>
        </Row>
        <Row className="justify-content-center text-sm  mt-2">
          <Col className="text-center">
            <Link href="/general-terms" className="subtitle text-secondary">
              allmänna villkor
            </Link>
          </Col>
        </Row>
        <OnlyOnFlaivySite>
          <Row className="justify-content-center text-sm  mt-2">
            <Col className="text-center">
              <Link
                href="/ip-cert.pdf"
                className="subtitle text-secondary"
                target="_blank"
              >
                IP-certifiering
              </Link>
            </Col>
          </Row>
          <Row className="justify-content-center text-sm  mt-2">
            <Col className="text-center">
              <Link
                href="/eko-cert.pdf"
                className="subtitle text-secondary"
                target="_blank"
              >
                EKO-certifiering
              </Link>
            </Col>
          </Row>
        </OnlyOnFlaivySite>
      </Container>
    </footer>
  );
}

// @ts-ignore
const mapStateToProps = ({ shopConfig }) => ({ shopConfig });

Footer.propTypes = {
  shopConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Footer);
